import React, { useId } from 'react';

// Stamp-style seals that state verifiable facts only. Deliberately not certification
// marks: no Halal or organic logos unless the farm holds those certificates.
export const seals = [
  { top: 'Single Origin', bottom: 'Uganda', center: 'UG' },
  { top: 'Pure Robusta', bottom: 'No Additives', center: null },
  { top: 'Duty Paid', bottom: 'Karachi Stock', center: 'PKR' },
  { top: 'Harvest', bottom: 'Nabutaka', center: '2026' },
];

function Seal({ top, bottom, center, tone }) {
  const id = useId().replace(/:/g, '');
  const dark = tone === 'dark';
  const ink = dark ? 'text-gold-400' : 'text-clay';

  return (
    <svg viewBox="0 0 120 120" className={`w-full h-auto ${ink}`} role="img" aria-label={`${top}, ${bottom}`}>
      <defs>
        {/* Top arc runs left to right over the crown; bottom arc runs left to right under the base */}
        <path id={`${id}-top`} d="M 20 60 A 40 40 0 0 1 100 60" />
        <path id={`${id}-bottom`} d="M 16 60 A 44 44 0 0 0 104 60" />
      </defs>
      <circle cx="60" cy="60" r="57" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="60" cy="60" r="31" fill="none" stroke="currentColor" strokeWidth="1" />
      <text className="fill-current font-body font-semibold uppercase" fontSize="9.5" letterSpacing="1.6">
        <textPath href={`#${id}-top`} startOffset="50%" textAnchor="middle">{top}</textPath>
      </text>
      <text className="fill-current font-body font-semibold uppercase" fontSize="9.5" letterSpacing="1.6">
        <textPath href={`#${id}-bottom`} startOffset="50%" textAnchor="middle">{bottom}</textPath>
      </text>
      <circle cx="13" cy="60" r="1.6" fill="currentColor" />
      <circle cx="107" cy="60" r="1.6" fill="currentColor" />
      {center ? (
        <text
          x="60"
          y="60"
          dy="0.35em"
          textAnchor="middle"
          className="fill-current font-heading"
          fontSize={center.length > 3 ? 17 : 22}
        >
          {center}
        </text>
      ) : (
        // Coffee bean: an oval with the centre crease
        <g transform="rotate(-30 60 60)" fill="none" stroke="currentColor" strokeWidth="1.5">
          <ellipse cx="60" cy="60" rx="10" ry="14" />
          <path d="M60 46 C 54 54, 66 66, 60 74" strokeLinecap="round" />
        </g>
      )}
    </svg>
  );
}

export default function Seals({ tone = 'light', className = '' }) {
  return (
    <ul className={`grid grid-cols-4 gap-3 sm:gap-5 ${className}`}>
      {seals.map((seal) => (
        <li key={seal.top} className="max-w-[112px] -rotate-6 odd:rotate-3">
          <Seal {...seal} tone={tone} />
        </li>
      ))}
    </ul>
  );
}
